import { PlaceholderShimmerBackground } from 'utils/fragments';
import { Switch } from '@headlessui/react';
import { forwardRef } from 'react';
import styled from 'styled-components';

const FlavorCatFourButtonLabel = styled(Switch)`
    text-align: left;
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => 'transparent'};
    color: ${({ theme, checked }) => (checked ? theme.purple_2 : theme.gray_2)};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme, checked }) =>
        checked ? theme.purple_2 : theme.gray_5};
    box-sizing: border-box;
    border-radius: ${({ theme }) => theme.borderRadius_md};

    font-family: ${({ theme }) => theme.style_primary};
    font-weight: ${({ theme }) => theme.fontSemiBold};
    font-size: ${({ theme }) => theme.space_7}px;
    line-height: ${({ theme }) => theme.space_8}px;
    text-transform: capitalize;

    padding: 10px;

    &:hover,
    &:focus-visible {
        background-color: ${({ theme, checked }) =>
            checked ? theme.purple_5 : theme.gray_7};
        border-color: ${({ theme }) => theme.purple_1};
    }

    &:disabled,
    &[disabled],
    &[aria-disabled='true'] {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:disabled,
    &[disabled],
    &[aria-disabled='true'],
    &disabled:hover,
    &[disabled]:hover,
    &[aria-disabled='true']:hover,
    &:hover,
    &:focus-visible {
        background-color: ${({ theme, checked, isLoading }) =>
            checked ? theme.purple_5 : isLoading ? theme.gray_5 : theme.gray_7};
    }

    ${({ isLoading }) => isLoading && PlaceholderShimmerBackground}
    ${({ isLoading }) => isLoading && `min-width: 8rem;`}
`;

const FlavorCatFourButton = forwardRef(
    (
        { checked, onChange, children, preserveIconSpace = true, ...props },
        ref,
    ) => (
        <FlavorCatFourButtonLabel
            checked={checked}
            onChange={onChange}
            {...props}
            ref={ref}
        >
            {children}
        </FlavorCatFourButtonLabel>
    ),
);

export default FlavorCatFourButton;
